export default {
    hCenter: {
        title: '幫助中心',
        titleMore: '更多問題',
        titleDetail: '問題詳情',
        c1: '自助工具',
        c2: '換一批',
        c3: '你可能想知',
        c4: '查看更多問題',
        c5: '更多服務',
        c6: '即時CHAT(僅通訊查詢)',
        c7: '客戶服務熱線',
        c8: '預約服務',
        c9: '門市地點',
        c10: '我要反饋',
        c11: '我的賬戶',
        c12: '我的賬單',
        c13: '繳付賬單',
        c14: '增值卡增值',
        c15: '用量查詢',
        c16: '國際漫遊',
        c17: '優惠專區',
        c18: '答案解決唔到問題？',
        c19: '原因話俾我地知，我們將提供更好嘅服務',
        c20: '答案文字太多，記唔住',
        c21: '答案無講清楚問題出現嘅原因',
        c22: '答案無講清楚點做可以解決問題',
        c23: '其他',
        c24: '感謝反饋',
        c25: '更多問題',
        c26: '目錄',
        c27: '答案用詞太專業，睇唔明',
        c28: '積分商城',
        c29: '門市地址',
        c30: '地址',
        c31: '營業時間',
        f1: '轉數快',
        f2: '實際支付金額',
        f3: '此<i class="i">一次性</i>二維碼有效期<i class="i">2分鐘</i>，請閣下於其他應用程式完成支付後<i class="i">返回MyLink確認支付結果</i>。如需再次支付，請返回前一頁再次進入此頁以<i class="i">刷新二維碼</i>。',
        f6: '如有使用電子券/積分但支付未成功，電子券/積分將在',
        f7: '2小時後',
        f8: '退回閣下帳戶並可再次使用。',
        f9: '二維碼將於',
        f10: '後失效',
        f11: '「教學」',
        f12: '此手機',
        f13: '付款',
        f14: '「教學」',
        f15: '另一部手機',
        f16: '付款',
        f17: '「教學」此手機付款',
        f18: '請截圖或長按保存二維碼',
        f19: '打開已安裝的支援FPS商戶二維碼支付的流動銀行應用程式',
        f20: '使用二維碼掃描功能，選擇導入此二維碼圖片進行付款',
        f21: '成功付款後返回MyLink查看付款成功提示',
        f22: '「教學」另一部手機付款',
        f23: '請閣下打開另一部手機上已安裝的支援FPS商戶二維碼支付的流動銀行應用程式',
        f24: '使用二維碼掃描功能直接掃描FPS二維碼進行付款',
        f25: '成功付款後返回MyLink查看付款成功提示',
        f26: '警告',
        f27: '二維碼已失效，請返回前一頁後再次進入此頁以刷新二維碼。\n' +
            '如有使用電子券/積分，將在2小時後退回閣下帳戶並可再次使用。',
        f28: '確定',
    }
}



// WEBPACK FOOTER //
// ./src/locale/FPS/zh-hk.js